webpackJsonp([15666838199965],{

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsPage = function TermsPage() {
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Terms of Use'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Effective May 25, 2018'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Welcome to Whistle! This website is owned and operated by Whistle Messaging, Inc. (',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u201CWhistle\u201D'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u201Cus\u201D'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u201Cour\u201D'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'or \u201Cwe\u201D'
	      ),
	      '). These Terms of Use (',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '"Terms"'
	      ),
	      ') set forth the terms and conditions under which you are authorized to use our messaging service, and website, including any website where these Terms are posted, and any subdomains and mobile versions thereof (collectively, the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u201CPlatform\u201D'
	      ),
	      ').'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To the extent additional rules or guidelines affect your use of our Platform, those rules and guidelines (including our ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/privacy' },
	        'Privacy Policy'
	      ),
	      ') are hereby incorporated by reference into these Terms. By using any of our Platform, you agree to these Terms. If you do not agree to these Terms, you should immediately stop using our Platform. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Through your use of our Platform, you acknowledge these Terms.'
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'No Access to Emergency Services'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The Platform is not a replacement for your ordinary mobile or fixed line telephone. The Platform does not allow you to make emergency calls or send emergency messages to emergency services. You must make alternative communications arrangements to ensure that you can make emergency calls and send emergency messages if needed.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You acknowledge and agree that: (i) Whistle is not required to offer access to emergency services under any applicable federal state or local law or regulation; (ii) it is your sole responsibility to ensure that you have access to traditional wireless (mobile) or fixed line telephone services that offer access to emergency services, and (iii) the Platform is not a replacement for your primary telephone and/ or messaging service(s).'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Third-party Platform and Content'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We provide our services on behalf of our third party hotels and other hospitality clients (',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u201CClients\u201D'
	      ),
	      '), and may use third party service providers in order to provide features or services to you. Except in connection with their use of our Platform, our Clients and other third parties are not governed by these Terms. You acknowledge and agree that we are not responsible for these parties\u2019 use of information you provide them. You further acknowledge that any reliance on representations and warranties provided by any party other than Whistle will be at your own risk. Your use of Client websites and services will subject to the terms of use and privacy policies posted on each site or service, and we encourage you to review those agreements.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Consent to Electronic Communications'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'By using the Platform, you agree that Whistle may communicate with you electronically regarding your use of the Platform and that any notices, agreements, disclosures or other communications that Whistle sends to you electronically will satisfy any legal communication requirements, including that the communications be in writing. To withdraw your consent from receiving electronic notice, please notify Whistle at info@trywhistle.com.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Modifications and Interruption to the Platform'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We reserve the right to modify or discontinue all or any portion of our Platform with or without notice to you. We will not be liable if we choose to exercise this right. You acknowledge and accept that we do not guarantee continuous, uninterrupted or secure access to our Platform, or that our Platform will be error free. You understand that usage of our Platform may be interfered with or adversely affected by numerous factors or circumstances outside of our control.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Your Access to the Platform'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'As a condition of your right to access and use our Platform, you represent that you are of legal age to enter into a binding contract and that you are not a person barred from accessing the Platform under the laws of the United States or any other country. Whistle reserves the right to terminate your access with or without reason at any time. YOU ARE ENTIRELY RESPONSIBLE FOR ALL ACTIVITIES CONDUCTED IN CONNECTION WITH THE USE OF THE PLATFORM ON YOUR DEVICE(S).'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Data Compliance'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Clients are responsible for obtaining any consent necessary to imitate communications via SMS, and for their processing of any Personal Information. However, Whistle may provide tools to collect or withdraw consents from users for SMS messaging via an SMS opt-in/out process, a voice response, electronic response, or other appropriate methods. Whistle\u2019s Clients are responsible for obtaining any necessary consent, and giving effect to users\u2019 choices, notwithstanding any options provided by Whistle.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Whistle may process this data as set forth in the Whistle ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/privacy' },
	        'Privacy Policy'
	      ),
	      ', including (without limitation) by disclosing such information to a Client and Client\u2019s authorized users, as well as any other third parties. Clients and other third parties may be the owners or controllers of the information you provide, and may disclose and/or use the information for their own purposes. Please review our ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/privacy' },
	        'Privacy Policy'
	      ),
	      ' for more information.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Restricted Activities'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You may not engage in any of the following with regard to the Platform (including without limitation posting or transmitting content through the Platform):'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'violate or encourage the violation of any local, state, national, or international law or regulation;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'collect or store personal data about other users of our Platform or solicit personal information from any individual without proper rights or consent of the individual;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'send or promote any message that is unlawful, libelous, defamatory, abusive, sexually explicit, threatening, vulgar, obscene, profane, disparaging regarding racial, gender or ethnic background, any statement that you have reason to know is false or misleading, or otherwise objectionable messages, as determined by Whistle in its sole discretion;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'infringe any patent, trademark, trade secret, copyright, right of publicity or privacy, or other right of any party, or distribute any content you do not have a right to make available under any law or under contractual or fiduciary relationships; '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'promote or distribute any unauthorized advertising, promotional materials, or material which can be characterized as "junk mail," "spam," "chain letters," "pyramid schemes," or similar material, any request for or solicitation of money, goods, or services for private gain, or any information posted primarily for advertising, promotional, or other commercial purposes;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'disrupt or interfere with the security or use of the Platform or any websites or content linked to them;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'interfere with or damage the integrity of the Platform, including, without limitation, through the use of viruses, Trojan horses, harmful code, denial of service attacks, packet or IP spoofing, forged routing or email address information or similar methods or technology or disobey any requirements, procedures, policies, or regulations of networks connected to our Platform;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'use the Service to store or transmit code, files, scripts, agents or programs intended to do harm, including, for example, viruses, worms, time bombs or Trojan horses;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'attempt to use another user, person or entity, misrepresent your affiliation with a person or entity, including (without limitation) Whistle or create or use a false identity; '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'attempt to obtain unauthorized access to the Platform or portions thereof that are restricted from general access; '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'use any meta tags or any other \u201Chidden text\u201D utilizing Whistle name, trademarks, or product names; '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'attempt to reverse engineer or otherwise derive or obtain the code in any form for any software used in the Platform; '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'engage in any activity that interferes with any third party\u2019s ability to use or enjoy the Platform; or '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'assist any third party in engaging in any activity prohibited by these Terms.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Further, without our written consent, you may not:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'reproduce, duplicate, copy, sell, resell, create derivative works, or exploit for any commercial purpose any Whistle content or any use of or access to the Platform'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'use any high volume, automated, or electronic means (including, without limitation, robots, spiders, scripts, or other automated devices) to access the Platform or monitor or copy our web pages or the content contained thereon; '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'deep link to the Platform for any purpose; or frame the Platform, place pop-up windows over any content, or otherwise affect the display of the Platform;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'access the Service in order to build a competitive service or to benchmark with a non-Whistle service; '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'everse engineer the Service (to the extent such restriction is permitted by law).'
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'TO THE FULLEST EXTENT PERMITTED BY LAW, WHISTLE, ITS RELATED ENTITIES, ITS SERVICE PROVIDERS, ITS LICENSORS, AND ITS OR THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES OR AGENTS (COLLECTIVELY THE \u201CCOMPANY PARTIES\u201D) EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT, RELATED TO OUR SITES. \u2028YOU UNDERSTAND AND AGREE THAT YOUR USE OF OUR SITES IS AT YOUR SOLE RISK. OUR SITES AND ALL CONTENT, PRODUCTS AND SERVICES OFFERED THROUGH THE SITES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. THE COMPANY PARTIES ARE NOT RESPONSIBLE FOR THE TIMELINESS OF DELIVERY OF CONTENT, ANY FAILURES OF DELIVERY, ERRONEOUS DELETION, OR ANY LOSS OR DAMAGE OF ANY KIND YOU CLAIM WAS INCURRED AS A RESULT OF THE USE OF ANY SITES. UNDER NO CIRCUMSTANCES, WILL ANY OF THE COMPANY PARTIES BE LIABLE TO YOU OR TO ANY PERSON OR ENTITY CLAIMING THROUGH YOU FOR ANY LOSS, INJURY, LIABILITY OR DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR ACCESS TO, USE OF, INABILITY TO USE, OR RELIANCE ON ANY OF OUR SITES OR ANY CONTENT, PRODUCT OR SERVICE PROVIDED TO YOU THROUGH OR IN CONNECTION WITH ANY OF OUR SITES. THIS IS A COMPREHENSIVE LIMITATION OF LIABILITY THAT APPLIES TO ALL LOSSES AND DAMAGES OF ANY KIND WHATSOEVER, WHETHER DIRECT OR INDIRECT, GENERAL, SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY OR OTHERWISE, INCLUDING WITHOUT LIMITATION, LOSS OF DATA, GOODWILL, REVENUE OR PROFITS. THIS LIMITATION OF LIABILITY APPLIES WHETHER THE ALLEGED LIABILITY IS BASED ON CONTRACT, NEGLIGENCE, TORT, STRICT LIABILITY OR ANY OTHER BASIS; EVEN IF ANY COMPANY PARTY HAS BEEN ADVISED OF OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES; AND WITHOUT REGARD TO THE SUCCESS OR EFFECTIVENESS OF OTHER REMEDIES. \u2028IF ANY PART OF THIS LIMITATION OF LIABILITY IS FOUND TO BE INVALID, ILLEGAL OR UNENFORCEABLE FOR ANY REASON, THEN THE AGGREGATE LIABILITY OF THE COMPANY PARTIES UNDER SUCH CIRCUMSTANCES TO YOU OR ANY PERSON OR ENTITY CLAIMING THROUGH YOU FOR LIABILITIES THAT OTHERWISE WOULD HAVE BEEN LIMITED WILL NOT EXCEED ONE HUNDRED U.S. DOLLARS.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR CERTAIN TYPES OF DAMAGES. ACCORDINGLY, SOME OF THE ABOVE DISCLAIMERS OF WARRANTIES AND LIMITATIONS OF LIABILITY MAY NOT APPLY TO YOU.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You acknowledge that you may have or may in the future have claims against us which you do not know or suspect to exist in your favor when you agreed to these Terms and which if known, might materially affect your consent to these Terms. You expressly waive all rights you may have under Section 1542 of the California Civil Code, which states:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'IF THIS CLAUSE IS HELD TO BE UNENFORCEABLE IN WHOLE OR IN PART IN ANY JURISDICTION DUE TO RELEVANT LAWS, THEN IN NO EVENT SHALL OUR OR THE RELEASEES\u2019 TOTAL LIABILITY TO YOU EXCEED $100.00. NOTHING IN THIS CLAUSE SHALL LIMIT OR EXCLUDE ANY LIABILITY FOR DEATH OR PERSONAL INJURY RESULTING FROM NEGLIGENCE.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Indemnification'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You agree to indemnify and hold the Whistle Parties harmless from any claim or demand, including reasonable attorney\'s fees and costs, made by any third party due to or arising out of your posting of any content on our Platform, or other use of our Platform in a manner not permitted by these Terms, including without limitation your actual or alleged violation of these Terms, or infringement of a third party\u2019s intellectual property or other rights by you or another user of our Platform using your computer, mobile device or account.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Copyright and Trademark Information'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'All content, copyrights and other intellectual property rights in the content available on our Platform, including without limitation design, text, graphics, interfaces, and the selection and arrangements thereof (collectively \u201CContent\u201D), are owned by Whistle or its Clients, with all rights reserved, or in some cases may be licensed to Whistle or its Clients by third parties. This Content is protected by the intellectual property rights of Whistle or those owners. All Content which qualifies for protection under U.S. Federal Copyright Law is subject to the exclusive jurisdiction of the Federal Court System, whether registered or unregistered. All trademarks displayed on our Platform are the trademarks of their respective owners, and constitute neither an endorsement nor a recommendation of such parties. In addition, such use of trademarks or links to the websites of third parties is not intended to imply, directly or indirectly, that those third parties endorse or have any affiliation with Whistle.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Permitted Use of the Content'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Any use of Content on the Platform, including without limitation reproduction for purposes other than those noted herein, modification, distribution, replication, any form of data extraction or data mining, or other commercial exploitation of any kind, without prior written permission of an authorized officer of Whistle or as part of a Client agreement with Whistle, is strictly prohibited. With the exception of search engines, you agree that you will not use any robot, spider, or other automatic device, or manual process to monitor or copy our web pages or the Content contained therein without prior written permission of an authorized officer of Whistle. You may not make any use of Content owned by any third parties which is available on the Platform, without the express consent of those third parties.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Content Complaints'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you believe that any Content on our Platform violates these Terms or is otherwise inappropriate, please report the content by contacting us by mail at:'
	    ),
	    _react2.default.createElement(
	      'address',
	      null,
	      'Whistle Messaging, Inc.',
	      _react2.default.createElement('br', null),
	      '31416 Agoura Road #105',
	      _react2.default.createElement('br', null),
	      'Westlake Village, CA, 91361',
	      _react2.default.createElement('br', null),
	      'United States',
	      _react2.default.createElement('br', null)
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Notification of Claimed Copyright Infringement'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the event that you find content posted on our Platform which you believe to be an infringement of the copyright ownership or other intellectual property rights of your company or any third party, you are requested to immediately contact Whistle\u2019s Copyright Agent as described below. To report any alleged infringement, please contact us in writing by providing a signed statement containing the following information pursuant to the Digital Millennium Copyright Act (',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '"DMCA"'
	      ),
	      '):'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Your name, address, telephone number, and email address, and if you are acting on behalf of the owner of the intellectual property, the name of the owner;'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'a statement, made under penalty of perjury, that you are the owner of the copyright or are authorized to act on behalf of the owner;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'a detailed description of the copyrighted work or other intellectual property that you claim has been infringed;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'if your claim is based on a registered work, the registration number, and the date of issuance of the registration;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'a description of the infringing material and the URL where such material is located on the Platform, or a description of where on our Platform you found such material;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'your written statement that you believe, in good faith, that the use of the work on our Platform has not been authorized by the true owner of the work, its agent, or as a matter of law; and'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'a statement that all of the information you have provided is true.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please send your notice of alleged infringement to us:'
	    ),
	    _react2.default.createElement(
	      'address',
	      null,
	      'Whistle Messaging, Inc.',
	      _react2.default.createElement('br', null),
	      '31416 Agoura Road #105',
	      _react2.default.createElement('br', null),
	      'Westlake Village, CA, 91361',
	      _react2.default.createElement('br', null),
	      'United States',
	      _react2.default.createElement('br', null)
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'E-mail: copyright@trywhistle.com, subject line \u201CDMCA Notice\u201D'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In accordance with the DMCA, it is the policy of Whistle to terminate use of our Platform by repeat infringers in appropriate circumstances.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'User-Submitted Content'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Any content uploaded, posted, submitted, or otherwise made available by individual users of the Platform, including without limitation all messages, and any other content which does not originate with Whistle ("User Content"), is the sole responsibility of the person who made such User Content available on the Platform. Under no circumstances will Whistle be liable in any way for any User Content made available through this Platform by you or any third party.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Since Whistle does not control the User Content posted on the Platform, it does not guarantee the truthfulness, integrity, suitability, or quality of that User Content, and it does not endorse such User Content. You also agree and understand that by accessing the Platform, you may encounter content that you may consider to be objectionable. User Content is owned by the author thereof, and Whistle does not claim ownership of original works created and posted by individual visitors to this Platform. Whistle reserves the right (but has no obligation) in its sole discretion to pre-screen, edit, refuse, move or remove any User Content that is posted on the Platform. You agree that the exercise by Whistle of such discretion shall not convert or transform User Content to content owned or provided by Whistle, and the user who made such User Content available on the Platform will retain ownership thereof as described below.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'As required by California Law, we permit minors under the age of 18 to request the deletion of any content or information that the minor has publicly posted on our Platform. To request the removal of content or information you have posted on our Platform, please send a letter or email to the address below with (i) your name, (ii) a complete description of the content you would like removed, and (iii) the web address(es) of the content you would like removed. Please be aware that our fulfillment of this request does not ensure complete or comprehensive removal of the content or information you have posted on our Platform.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Providing Feedback to Whistle'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We welcome your comments and feedback about our Platform. All information and materials submitted to Whistle through the Platform or otherwise, such as any comments, feedback, ideas, questions, designs, data or the like regarding or relating to the Platform or the business of Whistle (collectively, ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '"Feedback"'
	      ),
	      '), will be considered NON-CONFIDENTIAL and NON-PROPRIETARY with regard to you, but Whistle reserves the right to treat any such Feedback as the confidential information of Whistle.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'By submitting Feedback to Whistle, you assign to the Whistle Parties, free of charge, all worldwide rights, title and interest in all copyrights and other intellectual property rights in such Feedback. The Whistle Parties will be entitled to use any Feedback you submit, and any ideas, concepts, know-how or techniques contained in any such Feedback, for any purpose whatsoever, including but not limited to developing, manufacturing and marketing products and services using such Feedback without restriction and without compensating you in any way. You are responsible for the information and other content contained in any Feedback you submit to us, including, without limitation, its truthfulness and accuracy.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'GOVERNING LAW; ARBITRATION'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'PLEASE READ THE FOLLOWING PARAGRAPHS CAREFULLY BECAUSE THEY REQUIRE YOU TO ARBITRATE DISPUTES WITH WHISTLE AND LIMIT THE MANNER IN WHICH YOU CAN SEEK RELIEF FROM WHISTLE.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'These Terms shall be governed by and construed in accordance with the laws of the State of California and the United States of America, without resort to any conflict of law provisions. In the event of any controversy or claim arising out of or relating in any way to these Terms or the Platform, you and Whistle agree to consult and negotiate with each other and, recognizing your mutual interests, try to reach a solution satisfactory to both parties. If the parties do not reach settlement within a period of 60 days, then either of the parties may, by notice to the other demand mediation under the mediation rules of the JAMS/Endispute (\u201CJAMS\u201D) in Los Angeles, California. Both you and Whistle both give up the right to litigate disputes and may not proceed to arbitration without first trying meditation, but you and Whistle are NOT required to arbitrate any dispute in which either party seeks equitable and other relief from the alleged unlawful use of copyrights, trademarks, trade names, logos, trade secrets or patents. Whether the dispute is heard in arbitration or in court, you and Whistle will not commence against the other a class action, class arbitration or other representative action or proceeding.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If settlement is not reached within 60 days after service of a written demand for mediation, any unresolved controversy or claim will be resolved by arbitration in accordance with the rules of JAMS before a single arbitrator in Los Angeles, California. The language of all proceedings and filings will be English. The arbitrator will render a written opinion including findings of fact and law and the award and/or determination of the arbitrator will be binding on the parties, and their respective administrators and assigns, and will not be subject to appeal. Judgment may be entered upon the award of the arbitrator in any court of competent jurisdiction. The expenses of the arbitration will be shared equally by the parties unless the arbitration determines that the expenses will be otherwise assessed and the prevailing party may be awarded its attorneys\u2019 fees and expenses by the arbitrator. It is the intent of the parties that, barring extraordinary circumstances, arbitration proceedings will be concluded within 90 days from the date the arbitrator is appointed. The arbitrator may extend this time limit only if failure to do so would unduly prejudice the rights of the parties. Failure to adhere to this time limit will not constitute a basis for challenging the award. Consistent with the expedited nature of arbitration, pre-hearing information exchange will be limited to the reasonable production of relevant, non-privileged documents, carried out expeditiously.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For any disputes that are not handled by arbitration, you agree that any action at law or in equity arising out of or relating to these Terms shall be filed only in the state and federal courts located in Los Angeles, California and you hereby irrevocably and unconditionally consent and submit to the exclusive jurisdiction of such courts over any suit, action or proceeding arising out of these Terms or the use of the Platform.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Compliance with Laws'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You assume all knowledge of applicable law and you are responsible for compliance with any such laws. You may not use our Platform in any way that violates applicable state, federal, or international laws, regulations, relevant guidance, or other government requirements.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Changes to These Terms'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We reserve the right, at any time, to modify, alter, or update these Terms without prior notice. You are encouraged to check this page regularly for changes to the Terms. Modifications will become effective immediately upon being posted to our Platform, without further notice to you. Your continued use of any of our Platform after such modifications are posted constitutes your acknowledgement and acceptance of such modifications, and you may not amend these Terms.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Other Terms'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If any provision of these Terms is determined by a court of law to be unlawful, void or unenforceable for any reason, the other provisions (and any partially-enforceable provision) shall not be affected thereby and shall remain valid and enforceable to the maximum possible extent, and the invalid provision will be modified as necessary to make it valid and enforceable while as closely as possible reflecting the original intentions of Whistle.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You agree that these Terms and any other agreements referenced herein may be assigned by us, in our sole discretion, to a third party in the event of a merger or acquisition or otherwise. These Terms shall apply in addition to, and shall not be superseded by, any other written agreement between us in relation to your participation as a contributor to our Platform.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You agree and understand that these Terms together with any other applicable click-through agreements you may have entered into regarding our Platform, constitutes the entire agreement between you and Whistle regarding your use of the Platform, and that any other prior agreements between you and Whistle are superseded by these Terms.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Any failure by Whistle to exercise its rights under these Terms or to enforce the terms hereof will not constitute a waiver of those rights. \u2028You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to use of our Platform or relating to these Terms must be filed within one (1) year after such claim or cause of action arose or be forever barred.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Contact Us'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you have any questions about these Terms, please feel free to please contact us at:'
	    ),
	    _react2.default.createElement(
	      'address',
	      null,
	      'Whistle Messaging, Inc.',
	      _react2.default.createElement('br', null),
	      '31416 Agoura Road #105',
	      _react2.default.createElement('br', null),
	      'Westlake Village, CA, 91361',
	      _react2.default.createElement('br', null),
	      'United States',
	      _react2.default.createElement('br', null)
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Notice for California Users'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Under California Civil Code Section 1789.3, California users of our Platform are entitled to the following specific consumer rights notice: The Complaint Assistance Unit of the Division of Consumer Platform of the California Department of Consumer Affairs may be contacted in writing at 1625 North Market Blvd., Sacramento, CA 95834, or by telephone at (916) 445-1254 or (800) 952-5210.'
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = TermsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tos-js-baf282c848647cedfe35.js